import L from 'leaflet';

// Keep in sync with the $rallies PHP array in templates/template-homepage.php
const RALLY_LOCATIONS = [
  {
    city: 'New York City / New Jersey',
    lat: 40.6822,
    lng: -73.9440,
    time: '2:00–5:00 PM',
    venue: 'Harriet Tubman Park, Brooklyn',
    contactLabel: '(929) 692-7609',
    contactHref: 'tel:+19296927609',
  },
  {
    city: 'Detroit',
    lat: 42.3762,
    lng: -83.0866,
    time: '1:00–4:00 PM',
    venue: 'Mama Akua Community House',
    contactLabel: '(313) 459-6008',
    contactHref: 'tel:+13134596008',
  },
  {
    city: 'Chicago',
    lat: 41.8138,
    lng: -87.6098,
    time: '1:00–4:00 PM (CST)',
    venue: 'Carruthers Center, Northeastern Illinois University',
    contactLabel: 'kammh369@gmail.com',
    contactHref: 'mailto:kammh369@gmail.com',
  },
  {
    city: 'DMV (DC / MD / VA)',
    lat: 38.9172,
    lng: -77.0292,
    time: '1:00–4:00 PM',
    venue: 'Thurgood Marshall Center for Service and Heritage',
    contactLabel: '(443) 722-0783',
    contactHref: 'tel:+14437220783',
  },
  {
    city: 'Greenville, SC',
    lat: 34.8526,
    lng: -82.3940,
    time: 'Starts 1:00 PM',
    venue: 'Elks Lodge',
    contactLabel: '(864) 901-8627',
    contactHref: 'tel:+18649018627',
  },
  {
    city: 'Kansas City, MO',
    lat: 39.0389,
    lng: -94.5497,
    time: '4:00 PM',
    venue: '7714 Prospect Ave.',
    contactLabel: 'info@KCreparationscoalition.org',
    contactHref: 'mailto:info@KCreparationscoalition.org',
  },
  {
    city: 'St. Louis, MO',
    lat: 38.6270,
    lng: -90.1994,
    time: 'Aug 29–30',
    venue: 'Black Is Back Coalition 18th Annual Conference (in-person & virtual)',
    contactLabel: 'BlackisBackCoalition.org',
    contactHref: 'https://www.blackisbackcoalition.org',
  },
  {
    city: 'London, England',
    lat: 51.5194,
    lng: -0.1270,
    time: '12:00–15:00 (BST)',
    venue: 'TUC Congress House, The Thompson Suite',
    contactLabel: '',
    contactHref: '',
  },
];

function rallyIcon() {
  return L.divIcon({
    className: 'hp-map__marker',
    html: '<span class="hp-map__marker-pin"><i class="bi bi-geo-alt-fill" aria-hidden="true"></i></span>',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -30],
  });
}

function popupHtml(loc) {
  const rows = [`<h3>${loc.city}</h3>`, `<p><strong>${loc.time}</strong></p>`];
  if (loc.venue) rows.push(`<p>${loc.venue}</p>`);
  if (loc.contactHref) rows.push(`<p><a href="${loc.contactHref}">${loc.contactLabel}</a></p>`);
  rows.push('<p><a href="#rallies-cards">View full details ↓</a></p>');
  return rows.join('');
}

function mountMap(container) {
  const map = L.map(container, {
    scrollWheelZoom: false,
    worldCopyJump: true,
    minZoom: 2,
  });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors',
    maxZoom: 18,
  }).addTo(map);

  const icon = rallyIcon();
  const markers = RALLY_LOCATIONS.map((loc) =>
    L.marker([loc.lat, loc.lng], { icon, title: loc.city, alt: `Rally location: ${loc.city}` })
      .addTo(map)
      .bindPopup(popupHtml(loc))
  );

  map.fitBounds(L.featureGroup(markers).getBounds().pad(0.25));

  // Move focus into the popup when it opens so keyboard/screen-reader users land somewhere useful
  map.on('popupopen', (e) => {
    e.popup.getElement()?.querySelector('.leaflet-popup-close-button')?.focus();
  });
}

// Lazily mount the map once the section nears the viewport, so OSM tiles
// aren't requested until a visitor actually scrolls near the rallies section.
export function initRalliesMapLazy() {
  const container = document.getElementById('rallies-map');
  if (!container) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          mountMap(container);
          observer.unobserve(container);
        }
      });
    },
    { rootMargin: '200px 0px' }
  );
  observer.observe(container);
}
